import React from 'react';

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

import { BrowserRouter, Routes, Route} from 'react-router-dom';

import { Home } from './views/Home';
import { Service } from './views/Service';
import { About } from './views/About';
import { Contact } from './views/Contact';
import PendingOrder from './views/orders/PendingOrder';
import DeliveredOrder from './views/orders/DeliveredOrder';
import CanceledOrder from './views/orders/CanceledOrder';
import { Signup } from './views/auth/Signup';
import { Login } from './views/auth/Login';
import { Password } from './views/auth/Password';
import { ActivateAccount } from './views/auth/ActivateAccount';
import { Order } from './views/orders/Order';
import { NewOrder } from './views/orders/NewOrder';
import TermsOfUse from './views/TermsOfUse';
import { NotFoundPage } from './views/NotFoundPage';
import ProtectedRoute from './app/route/ProtectedRoute';
import { Product } from './views/Product';
import { ResendEmail } from './views/auth/ResendEmail';


function App() {

  return (
    
    <BrowserRouter>
        <Routes>
    
          <Route path="/" element={ <Home /> }> </Route>

          <Route path="/produits" element={ <Product /> }> </Route>

          <Route path="/services" element={ <Service /> }> </Route>

          <Route path="/apropos" element={ <About /> }> </Route>

          <Route path="/contact" element={ <Contact /> }> </Route>


          {/* Toutes les routes protégées */}
          <Route element={<ProtectedRoute />}>
           
              <Route path="/commandes-en-cours" element={ <PendingOrder /> }> </Route>

              <Route path="/commandes-livrees" element={ <DeliveredOrder /> }> </Route>

              <Route path="/commandes-annulees" element={ <CanceledOrder /> }> </Route>

              <Route path="/commande/:id" element={ <Order /> }> </Route>

              <Route path="/nouveau-commande" element={ <NewOrder /> }> </Route>
          
          </Route>


          
          <Route path="/inscription" element={ <Signup /> }> </Route>

          <Route path="/activation-compte/:token" element={ <ActivateAccount /> }> </Route>

          <Route path="/connexion" element={ <Login /> }> </Route>

          <Route path="/mot-de-passe/:token" element={ <Password /> }> </Route>

          <Route path="/renvoie-email-activation/:email" element={ <ResendEmail /> }> </Route>


          <Route path="/condition-utilisation" element={ <TermsOfUse /> }> </Route>


          <Route path="*" element={ <NotFoundPage />  } ></Route> 
    
        </Routes>
      </BrowserRouter>
 

  );
}


export default App;
